export function USDCIcon({ variant = "blue" }: { variant?: "blue" | "alt" }) {
  if (variant === "alt") {
    return (
      <div className="relative h-12 w-12 md:h-25 md:w-25">
        <div className="absolute inset-0 flex items-center justify-center rounded-full bg-[#2775ca]">
          <svg viewBox="0 0 32 32" className="h-6 w-6 md:h-7 md:w-7">
            <circle cx="16" cy="16" r="14" fill="#2775ca" />
            <path
              d="M16 6C10.48 6 6 10.48 6 16s4.48 10 10 10 10-4.48 10-10S21.52 6 16 6zm1 17.93V25h-2v-1.07A6.02 6.02 0 0111 18h2c0 2.21 1.79 4 4 4s4-1.79 4-4-1.79-4-4-4a6 6 0 01-6-6c0-2.93 2.1-5.37 4.88-5.93V7h2v1.07C20.42 8.56 23 11.51 23 15h-2a4 4 0 00-8 0 4 4 0 004 4 6 6 0 016 6c0 2.93-2.1 5.37-4.88 5.93z"
              fill="white"
              opacity="0"
            />
            <text x="16" y="21" textAnchor="middle" fill="white" fontSize="20px" fontWeight="bold">
              $
            </text>
          </svg>
        </div>
        <div className="absolute -left-1 -top-1 flex h-10 w-10 items-center justify-center rounded-full border-2 border-[#0c0c0c] bg-[#374151] md:h-15 md:w-15">
          <svg viewBox="0 0 16 16" className="h-10 w-10">
            <line x1="4" y1="5" x2="12" y2="5" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
            <line x1="4" y1="8" x2="12" y2="8" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
            <line x1="4" y1="11" x2="12" y2="11" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </div>
      </div>
    );
  }

  return (
    <div className="relative h-16 w-16 md:h-25 md:w-25">
      <div className="absolute inset-0 flex items-center justify-center rounded-full bg-[#2775ca]">
        <svg viewBox="0 0 32 32" className="h-6 w-6 md:h-7 md:w-7">
          <circle cx="16" cy="16" r="14" fill="#2775ca" />
          <text x="16" y="21" textAnchor="middle" fill="white" fontSize="20px" fontWeight="bold">
            $
          </text>
        </svg>
      </div>
      <div className="absolute -left-1 -top-1 flex h-6 w-6 items-center justify-center rounded-full border-2 border-[#0c0c0c] bg-[#2775ca] md:h-15 md:w-15">
        <svg viewBox="0 0 16 16" className="h-3 w-3">
          <line x1="4" y1="8" x2="12" y2="8" stroke="white" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </div>
    </div>
  );
}

export function USDTIcon() {
  return (
    <div className="relative h-12 w-12 md:h-25 md:w-25">
      <div className="absolute inset-0 flex items-center justify-center rounded-full bg-[#26a17b]">
        <svg viewBox="0 0 32 32" className="h-6 w-6 md:h-7 md:w-7">
          <circle cx="16" cy="16" r="14" fill="#26a17b" />
          <text x="16" y="21" textAnchor="middle" fill="white" fontSize="20" fontWeight="bold">
            T
          </text>
        </svg>
      </div>
      <div className="absolute -left-1 -top-1 flex h-6 w-6 items-center justify-center rounded-full border-2 border-[#0c0c0c] bg-[#374151] md:h-15 md:w-15">
        <svg viewBox="0 0 16 16" className="h-14 w-14">
          <circle cx="5" cy="8" r="2" fill="white" />
          <circle cx="11" cy="8" r="2" fill="white" />
        </svg>
      </div>
    </div>
  );
}

interface AssetIconProps {
  tokenImage?: string;
  chainImage?: string;
  iconVariant?: "usdc" | "usdc-alt" | "usdt";
}

export function AssetIcon({ tokenImage, chainImage, iconVariant = "usdc" }: AssetIconProps) {
  if (tokenImage || chainImage) {
    return (
      <div className="relative h-24 w-24 md:h-28 md:w-28">
        {chainImage && (
          <img
            src={chainImage}
            className="absolute -left-4 -top-4 h-12 w-12 rounded-full object-cover md:h-14 md:w-14"
            alt="Chain logo"
          />
        )}
        {tokenImage ? (
          <img src={tokenImage} className="h-20 w-20 rounded-full object-cover md:h-24 md:w-24" alt="Token logo" />
        ) : iconVariant === "usdt" ? (
          <USDTIcon />
        ) : iconVariant === "usdc-alt" ? (
          <USDCIcon variant="alt" />
        ) : (
          <USDCIcon />
        )}
      </div>
    );
  }

  if (iconVariant === "usdt") {
    return <USDTIcon />;
  }

  if (iconVariant === "usdc-alt") {
    return <USDCIcon variant="alt" />;
  }

  return <USDCIcon />;
}
